import $ from "jquery";
import videojs from "video.js";
// import Aspiration from "@bd-utils/aspiration";
import compile from "@bd-utils/handlerbars-helper";
import getFileExtension from "@bd-utils/getFileExtension";
import copyTextToClipboard from "@bd-utils/copyTextToClipboard";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getState, subscribe } from "@bd-stores/store";
import { getPlayers, getUserFromId } from "@bd-stores/game-progress";
import { updateProfileFirebase } from "@bd-core/firebase-actions";

export const WaitingRoom = () => {
    const isWaitingRoom = $("#page-waitingroom").length > 0;

    if (!isWaitingRoom) return false;

    const elms = {
        pageWaitingRoom: "#page-waitingroom",
        waitingroom: ".waitingroom",
        waitingroomSubtitle: ".waitingroom__subtitle",
        everyoneReady: ".waitingroom__title .allready",
        waitingEveryone: ".waitingroom__title .stillwaiting",
        readyBtn: ".js-ready-btn",
        cancelBtn: ".js-cancel-game",
        messageboxForm: ".js-messagebox-form",
        messageboxName: ".js-messagebox-name",
        messageboxAvatar: ".js-messagebox-avatar",
        messageboxMsg: ".js-messagebox-message",
        messageboxSubmit: ".js-messagebox-submit",
        member: ".member",
        memberEmailValue: ".member-email span",
        startBtn: ".js-start-game",
        countdownSecond: ".waitingroom-countdown-timer .second .column.animate",
        countdownSecondNum:
            ".waitingroom-countdown-timer .second .column.animate .num",
        introVideo: "#intro-video",

        playerList: ".js-player-list",
        playerItem: ".js-player-item",
        deletePlayerBtn: ".js-player-item-delete",
        teamName: ".js-team-name",
        gameInfoLeave: ".js-leave-team",

        teamId: ".teamId",
        teamIdCopy: ".js-copy-team-id",
        teamIdValue: ".js-team-id-value",

        gameInfo: ".gameInfo",
        gameInfoBtn: ".gameInfo__btn",

        leaderPopup: ".js-leader-popup",

        // setup profile elements
        profileWrapper: ".profileBox",
        avatarWrapper: ".setAvatar",
        avatarImg: ".js-avatar",
        inputNameWrapper: ".setName",
        inputNickname: ".js-nickname",
        displayName: ".profileDisplay__name",
        displayAvatar: ".profileDisplay__avatar",
        avatarUpload: ".js-avatar-upload",
        uploadPreview: ".js-upload-preview",
        avatarUploadFilename: ".js-filename-avatar",
        submitProfile: ".js-save-profile",
        editProfileBtn: ".js-edit-profile",

        aspirationWall: ".js-aspiration-wall",
        aspirationPerson: ".aspiration__person",

        countdown: ".js-countdown",

        snackbar: ".snackbar",
        snackbarClose: ".snackbar__close",
    };

    /**
     * Get relative path of a url without the site / hostname
     *
     * @param {string} url
     */
    const getRelativeUrl = (url) => {
        const site = CONFIG.siteURL;
        return url.replace(site, "");
    };

    /**
     * Check is given url provided from avatar options or is it custom upload.
     * false mean it's provided avatar, true means it's custom upload
     *
     * @param {string} url file url to check
     */
    const checkIsCustomAvatar = (url) => {
        const options = CONFIG.avatarOptions;

        if (options.length < 1) return false;

        const getUrl = (k) => getRelativeUrl(options[k]);
        const provided = Object.keys(options).map((k) => getUrl(k));
        return !provided.includes(url);
    };

    /**
     * Get avatar url base on given id, will return undefined if not found
     *
     * @param {number} id
     */
    const getAvatarUrl = (id) => CONFIG.avatarOptions[id];

    const getIsCompleteProfile = () => {
        const user = getUserFromId(CONFIG.user.id);
        const isFilledName = $(elms.inputNickname).val() !== "";
        // const isSelectedAvatar = CONFIG.user.avatar?.length > 0;

        const players = getPlayers();
        const myData = players.find((p) => p.userId === user?.userId);
        const hasSetupProfile = Boolean(myData?.hasSetupProfile);
        const isCompleteProfile = isFilledName && hasSetupProfile;

        return isCompleteProfile;
    };
    const render = (rawData = {}) => {
        const user = getUserFromId(CONFIG.user.id);
        const isUploadAvatar = checkIsCustomAvatar(user.avatarURL);
        const isCompleteProfile = getIsCompleteProfile();

        const avatarOptions = Object.keys(CONFIG.avatarOptions).map((k) => ({
            value: k,
            url: CONFIG.avatarOptions[k],
            isSelected:
                isCompleteProfile && isUploadAvatar
                    ? false
                    : getRelativeUrl(CONFIG.avatarOptions[k]) ===
                      user.avatarURL,
        }));

        const data = {
            ...rawData,
            teamCode: CONFIG.firebase.team_code.toUpperCase(),
            isUploadAvatar,
            avatarOptions,
            user: getUserFromId(CONFIG.user.id),
        };

        const template = $("#page-waitingroom-template").html();
        const html = compile(template, data);
        $("#page-waitingroom").html(html);
    };

    // let aspiration = null;
    const renderAfterInitialized = () => {
        let hasRendered = false;

        subscribe(() => {
            const store = getState();
            if (!store.userProgress.isFirebaseInitialized) return;
            if (store.gameProgress.players.length < 1) return;
            if (hasRendered) return;
            hasRendered = true;

            render(getState().pageWaitingRoom);
            // aspiration = new Aspiration();
            // aspiration.setup();
        });
    };

    renderAfterInitialized();

    const updateUI = () => {
        const isCompleteProfile = getIsCompleteProfile();
        $(elms.profileWrapper).toggleClass("is-profile-set", isCompleteProfile);
        $(elms.pageWaitingRoom).toggleClass(
            "is-profile-set",
            isCompleteProfile,
        );
        $(elms.messageboxMsg).prop("disabled", !isCompleteProfile);
    };

    subscribe(() => {
        updateUI();
    });

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame().then(() =>
            setTimeout(() => {
                $(".aspiration").animate(
                    { scrollTop: $(".aspiration__wall").prop("scrollHeight") },
                    300,
                );
            }, 400),
        );
    } catch (e) {
        console.error(e);
    }
    //----------------------------------------------------------------------- End Initialize Firebase

    // -------------------------------------------------------------------- SETUP PROFILE

    const onToggleSetProfile = function () {
        const isOpen = $(elms.profileWrapper).hasClass("is-profile-set");
        const hasOpen = !isOpen;

        $(elms.profileWrapper).toggleClass("is-profile-set", hasOpen);
        $(elms.pageWaitingRoom).toggleClass("is-profile-set", hasOpen);
    };

    // on select avatar image
    const onAvatarSelect = function () {
        const $this = $(this);
        const avatarWrapper = $this.parents(elms.avatarWrapper);
        avatarWrapper.find(elms.avatarImg).removeClass("is-selected");
        $(elms.avatarUpload).val("");

        $this.addClass("is-selected");
    };

    const validateFile = (file) => {
        const validExtensions = ["jpg", "png", "jpeg"];
        const allowed = validExtensions.join(",");
        const extension = getFileExtension(file);
        const isValid = validExtensions.includes(extension);
        const message = $(".allowed-file").text();

        if (!isValid) {
            alert(`${message} ${allowed}`);
            return false;
        }

        return true;
    };

    const setUploadPreview = (file) => {
        const url = window.URL.createObjectURL(file);

        $(elms.avatarWrapper).find(elms.avatarImg).removeClass("is-selected");
        $(elms.profileWrapper).addClass("is-upload-avatar");
        $(elms.uploadPreview).parent().addClass("is-selected");
        $(elms.uploadPreview).attr("src", url);
    };

    // on upload avatar
    const onFileChange = function (e, data) {
        const $this = $(this);
        const file = $this[0].files[0];
        const isValid = validateFile(file);

        if (!isValid || !data) {
            const theAvatar = $(elms.avatarWrapper).attr("data-avatar");

            const $avatars = $(elms.avatarImg);
            const $avatar = $avatars.filter(`[data-avatar="${theAvatar}"]`);

            if ($avatar.length) {
                $avatar.addClass("is-selected");
            } else {
                $avatars.first().addClass("is-selected");
            }
        }

        setUploadPreview(file);
    };

    const updateAspirationProfile = function (players) {
        // update avatar and name on aspiration wall
        const $aspirationWall = $(elms.aspirationWall);

        players.forEach(function (player) {
            const hasMessage = $aspirationWall
                .children()
                .find(
                    elms.aspirationPerson + `[data-user-id=${player.userId}]`,
                );

            if (hasMessage.length > 0) {
                $.each(hasMessage, function (index, msg) {
                    $(msg)
                        .find(".aspiration__avatar")
                        .attr("src", player.avatarURL);
                    $(msg).find(".aspiration__name").text(player.name);
                });
            }
        });
    };

    /**
     * Complete profile setup and move into ready prompt
     *
     * @param {string} name
     * @param {string} avatar
     */
    const onCompleteProfile = (name, avatar = undefined) => {
        const user = getUserFromId(CONFIG.user.id);
        const avatarURL = avatar ? avatar : user.avatarURL;

        $(elms.displayAvatar)
            .first()
            .css("background-image", "URL(" + avatarURL + ")");
        $(elms.displayName).first().html(name);
        $(elms.profileWrapper).addClass("is-profile-set");
        $(elms.pageWaitingRoom).addClass("is-profile-set");
    };

    /**
     * Upload avatar into wordpress server
     * @param {File} avatar
     */
    const updateAvatarWordpress = (avatar) => {
        let formData = new FormData();
        formData.append("custom_avatar", avatar);
        return new Promise((resolve, reject) => {
            bdapi
                .post("member/submit-avatar", formData)
                .then((res) => {
                    const data = res.data || {};
                    if (!data?.success) return reject(data.data.msg);
                    return resolve(data.data);
                })
                .catch(() => {
                    return reject();
                });
        });
    };

    const validateName = () => {
        const name = String($(elms.inputNickname).val()).trim();
        const testString = /<\/?[a-z][\s\S]*>/i.test(name); // check if the string contain html tag
        let isValid = false;

        if (name.length > 0 && !testString) {
            isValid = true;
        }

        $(elms.profileWrapper).toggleClass("is-nickname-error", !isValid);

        return isValid;
    };

    const getShouldUpdateStatus = () => {
        const user = getUserFromId(CONFIG.user.id);
        const avatarID = Number(
            $(`${elms.avatarImg}.is-selected`).attr("data-avatar"),
        );
        const selectedAvatar = avatarID
            ? getRelativeUrl(getAvatarUrl(avatarID))
            : null;
        const avatarFileName = String($(elms.avatarUpload).val());
        const newAvatar = selectedAvatar ?? getRelativeUrl(avatarFileName);
        const newName = String($(elms.inputNickname).val()).trim();
        const avatar = (newAvatar || newAvatar !== "") !== user.avatarURL;
        const name = newName !== user.name;

        return { avatar, name };
    };

    // on submit profile
    let isLoading = false;
    const onSubmitProfile = async function (e) {
        e.preventDefault();

        const $button = $(e.currentTarget);
        // const user = getUserFromId(CONFIG.user.id);
        const avatarImg = Number(
            $(`${elms.avatarImg}.is-selected`).attr("data-avatar"),
        );
        const default_avatar = CONFIG.default_avatar;
        const setAvatarImg = isNaN(avatarImg)
            ? default_avatar
            : getAvatarUrl(avatarImg);
        const name = String($(elms.inputNickname).val()).trim();
        const nickname = name
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");
        const isNameValid = validateName();

        /**
         * @type {JQuery<HTMLInputElement>}
         */
        const $customAvatar = $(elms.avatarUpload);
        const customAvatar = $customAvatar[0].files[0];
        const isUploadAvatar = !avatarImg && customAvatar;
        const shouldUpdate = getShouldUpdateStatus();

        if (isLoading) return;
        if (!isNameValid) return;

        $button.addClass("is-loading").prop("disabled", true);

        const unsetLoading = () => {
            $button.removeClass("is-loading").removeAttr("disabled");
        };

        const onUploadError = (err) => {
            unsetLoading();
            alert(err);
        };

        const shouldUpload = shouldUpdate.avatar && isUploadAvatar;
        const [uploadRes, uploadErr] = await bdjs.goAsync(
            shouldUpload
                ? updateAvatarWordpress(customAvatar)
                : Promise.resolve([false, undefined]),
        );

        if (uploadErr) {
            onUploadError(uploadErr);
            return;
        }

        let updateData = { hasSetupProfile: true };
        if (shouldUpdate.name) updateData.name = nickname;
        if (shouldUpdate.avatar)
            updateData.avatarURL = isUploadAvatar
                ? uploadRes.avatarURL
                : getRelativeUrl(setAvatarImg);

        updateProfileFirebase(updateData)
            .then(() => onCompleteProfile(nickname, updateData.avatarURL))
            .catch(alert)
            .finally(unsetLoading);
    };

    // ------------------------------------------------------------------- WAITING ROOM

    let isReady = false;
    const textReady = $(elms.readyBtn).data("ready");
    const textCancel = $(elms.readyBtn).data("cancel");

    const onPlayerStateChange = (e, eData) => {
        if (!eData || !eData.data) return;

        //handle ready state
        isReady = eData.data.ready;
        $(elms.gameInfo).toggleClass("is-ready", isReady);
        const newText = isReady ? textCancel : textReady;

        $(elms.readyBtn).find("span").text(newText);
        $(elms.readyBtn).toggleClass("is-ready", isReady);
    };

    bdjs.listen("bd__playerStateChanged", onPlayerStateChange);

    //On players changed
    //-------------------------------------------------------------------------
    let isLeaving = false;
    let kickedPopup = false;
    const updatePlayersOrKickMe = (players) => {
        const htmlTemplate = $("#tpl-user-item").html();

        const htmlPlayers = players.reduce((result, rawPlayer) => {
            const { siteURL, game, user } = CONFIG;
            const player = {
                ...rawPlayer,
                avatarURL: `${siteURL}${rawPlayer.avatarURL}`,
                is_leader: game.is_leader && user.id == rawPlayer.userId,
                isOffline: !rawPlayer.isOnline,
            };

            return rawPlayer.userId
                ? `${result}${compile(htmlTemplate, player)}`
                : result;
        }, "");

        $(elms.playerList).html(htmlPlayers);

        //check for kicked players
        const isCurrentPlayerExist =
            players.filter((p) => p.userId === CONFIG.user.id).length > 0
                ? true
                : false;

        if (!isCurrentPlayerExist && !isLeaving && !kickedPopup) {
            kickedPopup = true;
            const message = $(".removed-from-team").text();
            alert(message);
            window.location.reload();
            return false;
        }
    };

    const maybeReadyToStart = (players) => {
        let allReady = false;
        if (Array.isArray(players)) {
            let validPlayers = 0;
            let readyPlayers = 0;

            players.forEach((player) => {
                if (player.ready) readyPlayers++;
                if (player.userId) validPlayers++;
            });

            if (players.length > 1) {
                allReady = readyPlayers > 1 && readyPlayers == validPlayers;
            }

            if (CONFIG.game.game_prop.singlePlayer && readyPlayers > 0) {
                allReady = true;
            }
        }

        $(elms.waitingroomSubtitle).toggleClass("hide", allReady);

        if (allReady) {
            $(elms.everyoneReady).show();
            $(elms.waitingEveryone).hide();
        } else {
            $(elms.everyoneReady).hide();
            $(elms.waitingEveryone).show();
        }

        $(elms.startBtn).prop("disabled", !allReady);

        // $(elms.countdown).toggleClass("is-open", allReady);
    };

    const onPlayersStateChanged = (e, eData) => {
        /* Update players DOM */
        const players = eData?.data;
        updatePlayersOrKickMe(players);
        maybeReadyToStart(players);
        updateAspirationProfile(players);
    };

    bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);

    // On Team Data Changed
    // ------------------------------------------------------------------------
    const maybeTeamNameChanged = (teamData) => {
        if (
            $(elms.pageWaitingRoom).hasClass("is-leader") ||
            !teamData?.teamname
        )
            return;

        $(elms.teamName).val(teamData?.teamname);
    };

    const maybeTeamLeaderChanged = (teamData) => {
        const leaderId = teamData?.leader;

        if (!leaderId) return;

        const $elLeader = $(
            elms.playerItem.concat(`[player-id="${leaderId}"]`),
        );
        const leaderText = $(elms.playerList).attr("data-leader-text");
        const htmlLeader = `<div class="gamePlayer__teamLeader">${leaderText}</div>`;

        $elLeader.find(".js-leader-text").html(htmlLeader);

        if (leaderId == CONFIG.user.id && !CONFIG.game.is_leader) {
            CONFIG.game.is_leader = true;
            $(elms.leaderPopup).addClass("is-open");
            $(elms.pageWaitingRoom)
                .removeClass("is-member")
                .addClass("is-leader");
            $(elms.teamName).removeAttr("readonly");
            $elLeader.find(elms.deletePlayerBtn).addClass("hidden");
        }
    };

    let alreadyStarted = false;
    let countdownInterval;
    let countdownIndex = 1; // Move to module scope for reset
    let introVideoInstance = null; // Store videojs instance
    const stopInterval = () => {
        clearInterval(countdownInterval);
        $(elms.pageWaitingRoom).removeClass("is-countdown is-playing-intro");
        // Reset countdown UI
        $(".countdown__column.animate").css({
            transform: "translateY(0px)",
        });
        $(".countdown__column.zero").css({
            transform: "translateY(0px)",
        });
        countdownIndex = 1; // Reset index for next start
    };

    // Extracted countdown logic
    const runCountdown = (onComplete) => {
        countdownIndex = 1;
        const $countDownSecondNum = $(".countdown__num");
        const countdownTotal = $countDownSecondNum.length;
        const outerHeight = $countDownSecondNum.outerHeight(true);

        countdownInterval = setInterval(() => {
            if (countdownIndex === countdownTotal - 2) {
                clearInterval(countdownInterval);
                stopInterval();
                onComplete();
                return;
            }
            const newTranslate = 0 - countdownIndex * outerHeight;
            $(".countdown__column.animate").css({
                transform: "translateY(" + newTranslate + "px)",
            });
            countdownIndex++;
        }, 1000);
        $(elms.pageWaitingRoom).addClass("is-countdown");
    };

    const maybeStartTheGame = (teamData) => {
        if (!teamData?.isStarting || alreadyStarted) return;

        let isVideoError = false;
        alreadyStarted = true;

        const startTheGame = async () => {
            bdjs.showLoading();
            await bdjs.goAsync(bdapi.post("game/start-game"));
            setTimeout(() => {
                document.location.href = CONFIG.mainRoom;
            }, GameLogic.transisitonDuration);
        };

        // If no video, just run countdown and start the game
        if ($("#intro-video").length === 0) {
            runCountdown(startTheGame);
            return;
        }

        // Video.js logic
        if (!introVideoInstance) {
            introVideoInstance = videojs("intro-video", {
                controls: true,
                autoplay: false,
                preload: "auto",
            });

            introVideoInstance.on("loadeddata", () => {
                const tracks = introVideoInstance.textTracks();

                const track = tracks[0];
                if (!track) return;

                const cues = track.cues;
                if (cues.length === 0) return;

                const applyCueStyles = () => {
                    const activeCueElements = introVideoInstance
                        .el()
                        .querySelectorAll(".vjs-text-track-cue");
                    activeCueElements.forEach((el) => {
                        const htmlEl = /** @type {HTMLElement} */ (el);
                        const innerDiv = htmlEl.querySelector("div");
                        if (innerDiv) {
                            innerDiv.style.background = "transparent";
                            innerDiv.style.color = "#ffffff";
                            innerDiv.style.textShadow =
                                "0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0 0 12px rgba(0, 0, 0, 0.5)";
                        }
                    });
                };

                let timeupdateTimeout = null;
                introVideoInstance.on("timeupdate", () => {
                    if (timeupdateTimeout) {
                        clearTimeout(timeupdateTimeout);
                    }
                    timeupdateTimeout = setTimeout(() => {
                        applyCueStyles();
                    }, 100);
                });

                setTimeout(applyCueStyles, 100);

                for (let i = 0; i < cues.length; i++) {
                    const cue = cues[i];
                    cue.onenter = () => {
                        setTimeout(applyCueStyles, 0);
                    };
                }

                introVideoInstance.on("texttrackchange", () => {
                    applyCueStyles();
                });

                const textTrackDisplay = introVideoInstance
                    .el()
                    .querySelector(".vjs-text-track-display");
                if (textTrackDisplay) {
                    const observer = new MutationObserver(() => {
                        applyCueStyles();
                    });
                    observer.observe(textTrackDisplay, {
                        childList: true,
                        subtree: true,
                    });
                }
            });

            introVideoInstance.on("ended", function () {
                startTheGame();
            });

            introVideoInstance.on("error", function () {
                isVideoError = true;
            });
        } else {
            introVideoInstance.pause();
            introVideoInstance.currentTime(0);
        }
        const introVideo = introVideoInstance;

        runCountdown(() => {
            if (isVideoError) {
                startTheGame();
                return;
            }
            $(elms.pageWaitingRoom).addClass("is-playing-intro");
            try {
                introVideo.play().catch((error) => {
                    console.error("Unable to start auto play", error);
                });
            } catch (error) {
                console.error(error);
            }
        });
    };

    const onTeamStateChanged = (e, eData) => {
        const teamData = eData?.data;

        maybeTeamNameChanged(teamData);
        maybeTeamLeaderChanged(teamData);
        if (teamData?.isStarting === false) {
            stopInterval();
            alreadyStarted = false;
        } else {
            maybeStartTheGame(teamData);
        }
    };

    bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);

    // Setup Team state on first load
    // ------------------------------------------------------------------------
    const setTeamInitialState = (e, eData) => {
        const teamData = eData?.data;
        $(elms.teamName).val(teamData?.attributes?.teamname || "");

        fb.update(fb.teamAttributesPath, {
            isStarting: false, // Set to true if want to enable auto start the game
            teamname: CONFIG.user.display_name,
        });
    };

    bdjs.listen("bd__teamInitialState", setTeamInitialState);

    // Copy team id
    // ------------------------------------------------------------------------
    const onCopyTeamId = () => {
        const teamID = String($(elms.teamIdValue).val());
        const isCopied = copyTextToClipboard(teamID);
        if (!isCopied) return false;

        $(elms.teamId).addClass("is-copied");
        setTimeout(() => $(elms.teamId).removeClass("is-copied"), 1000);
    };

    // set team name on input
    // ------------------------------------------------------------------------\

    let timeToWait = 2; //seconds

    /**
     * @type {ReturnType<typeof setInterval> | undefined}
     */
    let intervalUpdate = undefined;

    $(document).on("input", elms.teamName, function () {
        const value = $(this).val();

        clearInterval(intervalUpdate);
        timeToWait = 2;
        intervalUpdate = setInterval(() => {
            timeToWait--;

            if (timeToWait <= 0) {
                clearInterval(intervalUpdate);

                fb.update(fb.teamAttributesPath, {
                    teamname: String(value).trim(),
                });
            }
        }, 1000);
    });

    // Kick player
    const onKickMember = async (e) => {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        const isLoading = $btn.hasClass("is-loading");
        if (isLoading) return false;

        const $playerToDelete = $btn.parents(elms.playerItem);
        const memberID = $playerToDelete.attr("player-id");
        if ($btn.hasClass("is-loading")) return;

        $btn.addClass("is-loading");

        await bdjs.goAsync(
            bdapi.post("member/kick-member", { member_id: memberID }),
        );

        $btn.removeClass("is-loading");
    };

    // Onboarding Box
    // ------------------------------------------------------------------------
    // let isLoading = false;
    // const onToggleReady = () => {
    //     fb.update(fb.currentPlayerPath, {
    //         ready: !isReady,
    //     });
    // };

    // Aspiration Box
    // ------------------------------------------------------------------------
    /**
     * Add message to firebase to be shown on aspiration
     * @param {string} message
     */
    const addMessage = (message) =>
        fb.push(fb.chatsPath, {
            userId: CONFIG.user.id,
            message,
        });

    const onAddMessage = (e) => {
        e.preventDefault();
        const message = String($(elms.messageboxMsg).val()).trim();
        if (message.length < 1) return false;

        addMessage(message);
        $(elms.messageboxMsg).val("");
        $(elms.messageboxSubmit).prop("disabled", true);
    };

    const manageChat = (e, eData) => {
        const msgData = eData.data;
        const players = getPlayers();
        if (!players.length) return;

        const sender = players.find(
            (p) => p?.userId && msgData?.userId && p.userId === msgData.userId,
        );

        if (sender) {
            // const classes = sender?.userId == CONFIG.user.id ? ["is-me"] : [];
            // aspiration.append(
            //     sender.userId,
            //     sender.name,
            //     msgData.message,
            //     sender.avatarURL,
            //     classes,
            //     msgData.isNew,
            // );
        }
    };

    bdjs.listen("bd__onChatSubmmited", manageChat);

    $(document).on("keypress", elms.messageboxMsg, function (e) {
        const key = e.which || e.keyCode || 0;
        const isEnterKey = key == 13;
        if (isEnterKey && !e.shiftKey) {
            e.preventDefault();
            $(elms.messageboxForm).trigger("submit");
            return false;
        }
    });

    $(document).on("input", elms.messageboxMsg, function () {
        const value = String($(this).val());
        const isDisabled = value.length < 1;
        $(elms.messageboxForm).find("button").prop("disabled", isDisabled);
    });

    // Countdown button start the game
    // ------------------------------------------------------------------------
    $(document).on("click", elms.startBtn, (e) => {
        e.preventDefault();

        const nickname = String($(elms.inputNickname).val()).trim();
        if (!nickname) {
            $(elms.snackbar).addClass("is-active");
            return;
        }
        fb.update(fb.teamAttributesPath, {
            isStarting: true,
            teamname: String($(elms.inputNickname).val()).trim(),
        });
    });

    $(document).on("click", elms.cancelBtn, (e) => {
        e.preventDefault();
        fb.update(fb.teamAttributesPath, { isStarting: false });
    });

    $(document).on("keydown", elms.inputNickname, (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            $(elms.startBtn).trigger("click");
        }
    });

    // Leave Game
    // ------------------------------------------------------------------------
    const onLeaveTeam = async (e) => {
        e.preventDefault();

        if (isLoading) return false;
        const message = $(".leave-team").text();
        const confirm_result = confirm(message);

        if (!confirm_result) {
            return false;
        }

        const $this = $(e.currentTarget);

        $this.addClass("is-loading");
        isLoading = true;
        isLeaving = true;

        await bdjs.goAsync(bdapi.post("member/leave-team"));
        window.location.reload();
        return false;
    };

    // Leader Popup
    // ------------------------------------------------------------------------

    const closeLeaderPopup = function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.parents(elms.leaderPopup).removeClass("is-open");
    };

    $(elms.leaderPopup)
        .find(".js-completionPopup-close")
        .on("click", closeLeaderPopup);

    $(document).on("click", elms.snackbarClose, () => {
        $(elms.snackbar).removeClass("is-active");
    });

    $(document).on("change", elms.avatarUpload, onFileChange);
    $(document).on("click", elms.editProfileBtn, onToggleSetProfile);
    $(document).on("click", elms.avatarImg, onAvatarSelect);
    $(document).on("click", elms.submitProfile, onSubmitProfile);
    $(document).on("click", elms.teamIdCopy, onCopyTeamId);
    $(document).on("click", elms.deletePlayerBtn, onKickMember);
    // $(document).on("click", elms.readyBtn, onToggleReady);
    // $(document).on("click", elms.cancelBtn, onToggleReady);
    $(document).on("click", elms.gameInfoLeave, onLeaveTeam);
    $(document).on("submit", elms.messageboxForm, onAddMessage);
    GameLogic.listenGameProgressChanged();
};
